interface LogoProps {
  className?: string;
  company: "Adobe" | "Notion" | "SpaceX" | "Webflow";
}

export const Logo = ({ className, company }: LogoProps) => {
  const logoPath = `/assets/onboarding/${company.toLowerCase()}-logo.svg`;

  return (
    <img
      src={logoPath}
      alt={`${company} logo`}
      className={className}
      loading="lazy"
    />
  );
};
